import type {FileWithPath} from "react-dropzone";

export function convertFileToBase64(file: FileWithPath | File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            if (reader.result) {
                resolve(reader.result.toString());
            } else {
                reject(new Error("Failed to convert file to Base64"));
            }
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
    });
}

function getMimeType(el: string): string | null {
    const mimeTypeMatch = el.match(/data:(.*?);/);
    return mimeTypeMatch ? mimeTypeMatch[1] : null;
}

export function convertBase64ToFile(base64: string) {
    const [bytesMimeType, bytes] = base64.split(',');
    const mimeType =  getMimeType(bytesMimeType);
    const byteCharacters = atob(bytes);
    const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], {type: mimeType ?? 'application/octet-stream'});
    return URL.createObjectURL(blob);
}